var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E86215"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9346,
    cy: 43.9336,
    r: 40,
    fill: "#E5451F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9883 46.1129V44.2649H23.8083V46.1129H14.9883Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2412 41.2409C38.9012 41.9129 40.6092 44.0689 40.6092 46.9529C40.6092 50.7329 37.6692 53.4489 33.5812 53.4489C29.6052 53.4489 26.8332 50.8449 26.7212 46.9809H31.5092C31.5652 48.2969 32.3772 49.1649 33.6092 49.1649C34.8692 49.1649 35.7652 48.2409 35.7652 46.8689C35.7652 45.4969 34.8412 44.6569 33.3852 44.6569H30.4172V43.6209L33.4412 38.6369H27.1972V34.3809H39.9652V35.2489L36.2412 41.2409Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8959 53.5049C45.9679 53.5049 42.7479 49.6689 42.7479 43.7329C42.7479 37.7689 45.9399 33.9609 50.8959 33.9609C55.8799 33.9609 59.0439 37.7689 59.0439 43.7329C59.0439 49.6689 55.8519 53.5049 50.8959 53.5049ZM50.8959 49.0809C52.8559 49.0809 53.9479 47.1769 53.9479 43.7329C53.9479 40.3169 52.8559 38.3849 50.8959 38.3849C48.9359 38.3849 47.8719 40.2889 47.8719 43.7329C47.8719 47.1489 48.9359 49.0809 50.8959 49.0809Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0466 51.9929H68.9746V53.0009H62.3026V52.8249L67.1826 45.3849H62.5906V44.3609H68.9106V44.5689L64.0466 51.9929Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.47 44.6649V45.7049L71.774 46.7129V53.0009H70.686V47.3529L68.99 48.3769V47.3369L70.686 46.3289V41.2889H71.774V45.6729L73.47 44.6649Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceBadge);
export default __webpack_public_path__ + "static/media/price-badge.c8233046a20356f0b6d8c6cc85d19fe8.svg";
export { ForwardRef as ReactComponent };